// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_application_search__5WFrM input[type='search'] {
    border-radius: 15px;
    border: 1px solid #45852e;
}

.table_application_search__5WFrM input[type='search']:focus {
    border: none;
    outline: none;
    border: 1px solid #45852e;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}

.table_application_filter__liEyb {
    color: #45852e;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
    border-radius: 8px;
    border: 1px solid #45852e;
    background: #fff;
}

.table_table__Egjtz {
    border-radius: 24px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    padding: 0px;
}

.table_table_header__i1C8f {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    border-bottom: 1px solid #ebebeb;
    background: #45852e;
    color: #fff;
}

.table_table_data__SOy0m {
    border-bottom: 1px solid #ebebeb;
    font-family: Karla;
}

.table_table_footer__uZban {
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    border-bottom: 1px solid #ebebeb;
    background: #45852e;
    color: #fff;
}

.table_table_data__SOy0m .table_approve__YhNFP {
    height: 32px;
    border-radius: 16px;
    background: #f3f9f0;
    color: #238e1a;
    font-family: Karla;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.28px;
}

.table_table_data__SOy0m .table_initiate__tD0WX {
    height: 32px;
    border-radius: 16px;
    background: #e1f2f9;
    color: #00639a;
    font-family: Karla;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.28px;
}

.table_table_data__SOy0m .table_pending__LBKrD {
    height: fit-content;
    border-radius: 16px;
    background: #f9f7d7;
    color: #9a7500;

    font-family: Karla;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.28px;
}

.table_pagenumber__OB-TN {
    padding: 3px 11px;
    border-radius: 80px;
    background: #45852e;
    color: #fff;
}

.table_arrow__v4zGv {
    border: none;
    color: #fff;
    background-color: transparent;
}

.table_applicationNumber__OoWf1 a {
    text-decoration: none;
}

.table_table-arrow__si63r {
    color: #238e1a;
}
`, "",{"version":3,"sources":["webpack://./src/features/modules/UserManagement/moduleComponents/table.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;;IAEd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".application_search input[type='search'] {\n    border-radius: 15px;\n    border: 1px solid #45852e;\n}\n\n.application_search input[type='search']:focus {\n    border: none;\n    outline: none;\n    border: 1px solid #45852e;\n    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.application_filter {\n    color: #45852e;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 160%;\n    border-radius: 8px;\n    border: 1px solid #45852e;\n    background: #fff;\n}\n\n.table {\n    border-radius: 24px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    padding: 0px;\n}\n\n.table_header {\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    border-bottom: 1px solid #ebebeb;\n    background: #45852e;\n    color: #fff;\n}\n\n.table_data {\n    border-bottom: 1px solid #ebebeb;\n    font-family: Karla;\n}\n\n.table_footer {\n    border-bottom-left-radius: 24px;\n    border-bottom-right-radius: 24px;\n    border-bottom: 1px solid #ebebeb;\n    background: #45852e;\n    color: #fff;\n}\n\n.table_data .approve {\n    height: 32px;\n    border-radius: 16px;\n    background: #f3f9f0;\n    color: #238e1a;\n    font-family: Karla;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%;\n    letter-spacing: -0.28px;\n}\n\n.table_data .initiate {\n    height: 32px;\n    border-radius: 16px;\n    background: #e1f2f9;\n    color: #00639a;\n    font-family: Karla;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%;\n    letter-spacing: -0.28px;\n}\n\n.table_data .pending {\n    height: fit-content;\n    border-radius: 16px;\n    background: #f9f7d7;\n    color: #9a7500;\n\n    font-family: Karla;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%;\n    letter-spacing: -0.28px;\n}\n\n.pagenumber {\n    padding: 3px 11px;\n    border-radius: 80px;\n    background: #45852e;\n    color: #fff;\n}\n\n.arrow {\n    border: none;\n    color: #fff;\n    background-color: transparent;\n}\n\n.applicationNumber a {\n    text-decoration: none;\n}\n\n.table-arrow {\n    color: #238e1a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"application_search": `table_application_search__5WFrM`,
	"application_filter": `table_application_filter__liEyb`,
	"table": `table_table__Egjtz`,
	"table_header": `table_table_header__i1C8f`,
	"table_data": `table_table_data__SOy0m`,
	"table_footer": `table_table_footer__uZban`,
	"approve": `table_approve__YhNFP`,
	"initiate": `table_initiate__tD0WX`,
	"pending": `table_pending__LBKrD`,
	"pagenumber": `table_pagenumber__OB-TN`,
	"arrow": `table_arrow__v4zGv`,
	"applicationNumber": `table_applicationNumber__OoWf1`,
	"table-arrow": `table_table-arrow__si63r`
};
export default ___CSS_LOADER_EXPORT___;
